export default "__VITE_ASSET__CDWdQMzk__"